import { createGlobalStyle } from 'styled-components';
// import { screen } from '../lib/utils';

export const ProdStyle = createGlobalStyle`
  body {
    background-color: ${({ theme }) => theme.colors.black} !important;
  }

  h2 {
    text-transform: none;
  }
`;

export default createGlobalStyle`
  @font-face {
    font-family: PF DIN Cond Pro;
    src: url(https://www.groglass.com/wp-content/themes/groglass/fonts/pfdintextcondpro-light.woff2) format("woff2"),
      url(https://www.groglass.com/wp-content/themes/groglass/fonts/pfdintextcondpro-light.woff) format("woff");
    font-weight: normal;
    font-style: normal
  }

  @font-face {
    font-family: PF DIN Cond Pro;
    src: url(https://www.groglass.com/wp-content/themes/groglass/fonts/pfdintextcondpro-medium.woff2) format("woff2"),
      url(https://www.groglass.com/wp-content/themes/groglass/fonts/pfdintextcondpro-medium.woff) format("woff");
    font-weight: bold;
    font-style: normal
  }

  @font-face {
    font-family: PF DIN Text Pro;
    src: url(https://www.groglass.com/wp-content/themes/groglass/fonts/pfdintextpro-light.woff2) format("woff2"),
      url(https://www.groglass.com/wp-content/themes/groglass/fonts/pfdintextpro-light.woff) format("woff");
    font-weight: normal;
    font-style: normal
  }

  @font-face {
    font-family: PF DIN Text Pro;
    src: url(https://www.groglass.com/wp-content/themes/groglass/fonts/pfdintextpro-medium.woff2) format("woff2"),
      url(https://www.groglass.com/wp-content/themes/groglass/fonts/pfdintextpro-medium.woff) format("woff");
    font-weight: bold;
    font-style: normal
  }

  ::before,
  ::after {
    text-decoration: inherit;
    vertical-align: inherit;
  }

  html {
    word-break: break-word;
  }

  body {
    margin: 0;
    background-color: ${({ theme }) => theme.colors.bg};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;
